module.exports = __webpack_public_path__ + "img/hand.5fb7fb19.png";